var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"o-icon o-icon--resume",on:{"click":_vm.replay}})
}
var staticRenderFns = []

export { render, staticRenderFns }